var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgBadge3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.795898,
    y: 0.499023,
    width: 36,
    height: 36,
    rx: 8,
    fill: "white",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1598_19186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0459 9.49902H13.5459C12.5513 9.49902 11.5975 9.89411 10.8942 10.5974C10.191 11.3006 9.7959 12.2545 9.7959 13.249V13.249C9.7959 13.8458 10.033 14.4181 10.4549 14.84C10.8769 15.262 11.4492 15.499 12.0459 15.499H25.5459C26.1163 15.506 26.6676 15.2939 27.0863 14.9064C27.5049 14.5188 27.7589 13.9855 27.7959 13.4163C27.818 12.9101 27.7373 12.4046 27.5588 11.9304C27.3803 11.4562 27.1077 11.023 26.7573 10.657C26.4069 10.291 25.986 9.99968 25.52 9.80067C25.054 9.60166 24.5526 9.49905 24.0459 9.49902V9.49902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2959 16.999H11.2959C11.097 16.999 10.9062 17.078 10.7656 17.2187C10.6249 17.3593 10.5459 17.5501 10.5459 17.749V23.749C10.5471 24.7432 10.9426 25.6964 11.6456 26.3994C12.3486 27.1024 13.3017 27.4978 14.2959 27.499H23.2959C24.2901 27.4978 25.2432 27.1024 25.9462 26.3994C26.6492 25.6964 27.0447 24.7432 27.0459 23.749V17.749C27.0459 17.5501 26.9669 17.3593 26.8262 17.2187C26.6856 17.078 26.4948 16.999 26.2959 16.999ZM21.0459 20.749H16.5459C16.347 20.749 16.1562 20.67 16.0156 20.5294C15.8749 20.3887 15.7959 20.1979 15.7959 19.999C15.7959 19.8001 15.8749 19.6093 16.0156 19.4687C16.1562 19.328 16.347 19.249 16.5459 19.249H21.0459C21.2448 19.249 21.4356 19.328 21.5762 19.4687C21.7169 19.6093 21.7959 19.8001 21.7959 19.999C21.7959 20.1979 21.7169 20.3887 21.5762 20.5294C21.4356 20.67 21.2448 20.749 21.0459 20.749Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1598_19186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9.7959 9.49902)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge3);
export default __webpack_public_path__ + "static/media/badge-3.5c21ae2ce0e7fe21b7493936ef134852.svg";
export { ForwardRef as ReactComponent };